import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Preloader from 'components/Preloader';
import { useTierConfig } from './useTierConfig';
import TierConfigHeader from './TierConfigHeader';
import TierPresetSelector from './TierPresetSelector';
import TierList from './TierList';
import DefaultTierSelector from './DefaultTierSelector';

const TierConfigSection = () => {
  const {
    tiers,
    defaultTier,
    defaultTierColor,
    isLoading,
    isSaving,
    isDirty,
    isUsingDefaults,
    validationErrors,
    addTier,
    removeTier,
    updateTier,
    reorderTiers,
    setDefaultTier,
    save,
    resetToDefaults,
    applyPreset,
  } = useTierConfig();

  if (isLoading) {
    return <Preloader overlay />;
  }

  return (
    <Box sx={{ p: 2 }}>
      <TierConfigHeader
        isUsingDefaults={isUsingDefaults}
        onResetToDefaults={resetToDefaults}
      />
      <TierPresetSelector onSelectPreset={applyPreset} />
      <TierList
        tiers={tiers}
        onUpdate={updateTier}
        onRemove={removeTier}
        onReorder={reorderTiers}
        validationErrors={validationErrors}
      />
      <Button
        variant="outlined"
        onClick={addTier}
        size="medium"
        sx={{ mt: 2 }}
      >
        + Add Tier
      </Button>
      <DefaultTierSelector
        tiers={tiers}
        defaultTier={defaultTier}
        defaultTierColor={defaultTierColor}
        onChange={setDefaultTier}
      />
      {validationErrors?.defaultTier && (
        <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1 }}>
          {Array.isArray(validationErrors.defaultTier)
            ? validationErrors.defaultTier[0]
            : validationErrors.defaultTier}
        </Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={save}
        disabled={!isDirty || isSaving}
        sx={{ mt: 2 }}
      >
        {isSaving ? 'Saving...' : 'Save Configuration'}
      </Button>
    </Box>
  );
};

export default TierConfigSection;
